var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDomains(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2634_93738",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2634_93738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6C7.08333 6 6.72933 6.146 6.438 6.438C6.146 6.72933 6 7.08333 6 7.5C6 7.91667 6.146 8.27067 6.438 8.562C6.72933 8.854 7.08333 9 7.5 9C7.91667 9 8.27067 8.854 8.562 8.562C8.854 8.27067 9 7.91667 9 7.5C9 7.08333 8.854 6.72933 8.562 6.438C8.27067 6.146 7.91667 6 7.5 6ZM7.5 16C7.08333 16 6.72933 16.146 6.438 16.438C6.146 16.7293 6 17.0833 6 17.5C6 17.9167 6.146 18.2707 6.438 18.562C6.72933 18.854 7.08333 19 7.5 19C7.91667 19 8.27067 18.854 8.562 18.562C8.854 18.2707 9 17.9167 9 17.5C9 17.0833 8.854 16.7293 8.562 16.438C8.27067 16.146 7.91667 16 7.5 16ZM4 3H20C20.2833 3 20.5207 3.09567 20.712 3.287C20.904 3.479 21 3.71667 21 4V11C21 11.2833 20.904 11.5207 20.712 11.712C20.5207 11.904 20.2833 12 20 12H4C3.71667 12 3.47933 11.904 3.288 11.712C3.096 11.5207 3 11.2833 3 11V4C3 3.71667 3.096 3.479 3.288 3.287C3.47933 3.09567 3.71667 3 4 3ZM5 5V10H19V5H5ZM4 13H20C20.2833 13 20.5207 13.0957 20.712 13.287C20.904 13.479 21 13.7167 21 14V21C21 21.2833 20.904 21.5207 20.712 21.712C20.5207 21.904 20.2833 22 20 22H4C3.71667 22 3.47933 21.904 3.288 21.712C3.096 21.5207 3 21.2833 3 21V14C3 13.7167 3.096 13.479 3.288 13.287C3.47933 13.0957 3.71667 13 4 13ZM5 15V20H19V15H5Z",
    fill: "#1F242F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomains);
export default __webpack_public_path__ + "static/media/domains.0aabecdf9590a631b7b7c8f35b78d4b5.svg";
export { ForwardRef as ReactComponent };